export default [{
  name: 'oficina',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PessoaBanco: {},
        PessoaEndereco: {},
        PessoaDadosContato: {},
        DocumentoFederal: ''
      },
      Parcela: {},
      CountGarantia: 0,
      CountAvalista: 0,
    },
    dadosIniciais: {
      pessoaParceiroLimiteCredito: {}
    }
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
    dadosIniciais (state, obj) {
      state.dadosIniciais = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    },
    dadosIniciais (state) {
      return state.dadosIniciais
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PessoaBanco: {},
          PessoaEndereco: {},
          PessoaDadosContato: {},
          DocumentoFederal: ''
        },
        Parcela: {},
        Proposta: {},
        CountAvalista: 0,
        CountGarantia: 0,
      }
      commit('model', data)
      commit('dadosIniciais', { pessoaParceiroLimiteCredito: {} })
    },
  }
}];
